/* MapleCrew Canada — Custom Theme JS */
(function(){
  'use strict';

  // Scroll reveal
  function reveal(){
    var obs = new IntersectionObserver(function(e){
      e.forEach(function(en){
        if(en.isIntersecting){ en.target.classList.add('in'); obs.unobserve(en.target); }
      });
    },{threshold:0.10,rootMargin:'0px 0px -30px 0px'});
    document.querySelectorAll('.mc-reveal').forEach(function(el){ obs.observe(el); });
  }

  // FAQ
  function faq(){
    document.querySelectorAll('.mc-qi__q').forEach(function(btn){
      btn.addEventListener('click',function(){
        var item = btn.closest('.mc-qi');
        var open = item.classList.contains('open');
        document.querySelectorAll('.mc-qi.open').forEach(function(i){i.classList.remove('open');});
        if(!open) item.classList.add('open');
      });
    });
  }

  // Mobile nav
  function mobileNav(){
    var ham = document.querySelector('.mc-hamburger');
    var nav = document.querySelector('.mc-mobile-nav');
    if(!ham||!nav) return;
    ham.addEventListener('click',function(){
      nav.classList.toggle('open');
    });
  }

  // Counters
  function counters(){
    var obs = new IntersectionObserver(function(e){
      e.forEach(function(en){
        if(!en.isIntersecting) return;
        var el = en.target;
        var target = parseInt(el.dataset.count,10);
        var suffix = el.dataset.suffix||'';
        if(isNaN(target)) return;
        var dur=1600, step=target/(dur/16), cur=0;
        function tick(){ cur=Math.min(cur+step,target); el.textContent=Math.floor(cur).toLocaleString()+suffix; if(cur<target)requestAnimationFrame(tick); }
        tick();
        obs.unobserve(el);
      });
    },{threshold:0.5});
    document.querySelectorAll('[data-count]').forEach(function(el){obs.observe(el);});
  }

  // Sticky header glow
  function header(){
    var h = document.querySelector('.mc-header');
    if(!h) return;
    window.addEventListener('scroll',function(){
      h.style.borderBottomColor = window.scrollY>60 ? 'rgba(204,0,0,0.3)' : 'rgba(255,255,255,0.07)';
    },{passive:true});
  }

  document.addEventListener('DOMContentLoaded',function(){
    reveal(); faq(); mobileNav(); counters(); header();
  });
})();
